export enum AssociationStatusEnum {
  Inactive = 0,
  Active = 1,
}
